module.exports = __webpack_public_path__ + "img/01.432da687.png";